/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Classification of a PAL submission error that drives the UX response:
 *   - `correctable`: input issue the user can fix and retry; UI offers "Correct Error & Retry"
 *   - `non_retriable`: deterministic failure where retry is pointless; UI prompts the user to submit manually
 * 
 * @export
 */
export const PalAuthErrorClassification = {
    Correctable: 'correctable',
    NonRetriable: 'non_retriable',
} as const;
export type PalAuthErrorClassification = typeof PalAuthErrorClassification[keyof typeof PalAuthErrorClassification];


export function instanceOfPalAuthErrorClassification(value: any): boolean {
    for (const key in PalAuthErrorClassification) {
        if (Object.prototype.hasOwnProperty.call(PalAuthErrorClassification, key)) {
            if (PalAuthErrorClassification[key as keyof typeof PalAuthErrorClassification] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalAuthErrorClassificationFromJSON(json: any): PalAuthErrorClassification {
    return PalAuthErrorClassificationFromJSONTyped(json, false);
}

export function PalAuthErrorClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthErrorClassification {
    return json as PalAuthErrorClassification;
}

export function PalAuthErrorClassificationToJSON(value?: PalAuthErrorClassification | null): any {
    return value as any;
}

export function PalAuthErrorClassificationToJSONTyped(value: any, ignoreDiscriminator: boolean): PalAuthErrorClassification {
    return value as PalAuthErrorClassification;
}

